/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApiAccountKycStatus401,
  GetApiAccountKycStatus403,
  GetApiAccountKycStatus500,
  GetApiAccountProfile422,
  KycStatusResponse,
  PasswordInitializeRequest,
  PasswordResetRequest,
  PasswordValidateRequest,
  PostAppAccountPasswordinitializeInvoke200,
  PostAppAccountPasswordinitializeInvoke400,
  PostAppAccountPasswordresetInvoke200,
  PostAppAccountPasswordresetInvoke400,
  PostAppAccountPasswordresetInvoke401,
  PostAppAccountPasswordvalidateInvoke200,
  PostAppAccountPasswordvalidateInvoke400,
  ProfileResponse,
} from '../placementApi.schemas.ts';

import getApiAccountKycStatusMutator from '.././mutator/placement-instance.ts';
import postAppAccountPasswordinitializeInvokeMutator from '.././mutator/placement-instance.ts';
import postAppAccountPasswordresetInvokeMutator from '.././mutator/placement-instance.ts';
import postAppAccountPasswordvalidateInvokeMutator from '.././mutator/placement-instance.ts';
import getApiAccountProfileMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation du statut KYC (Connaissance du Client) de l'utilisateur authentifie depuis Salesforce. Retourne OK si valide, KO sinon.
 * @summary Recuperation du statut KYC
 */
export const getApiAccountKycStatus = (signal?: AbortSignal) => {
  return getApiAccountKycStatusMutator<KycStatusResponse>({ url: `/api/account/kyc-status`, method: 'GET', signal });
};

export const getGetApiAccountKycStatusQueryKey = () => {
  return [`/api/account/kyc-status`] as const;
};

export const getGetApiAccountKycStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountKycStatus>>,
  TError = GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountKycStatus>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountKycStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountKycStatus>>> = ({ signal }) =>
    getApiAccountKycStatus(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountKycStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountKycStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAccountKycStatus>>>;
export type GetApiAccountKycStatusQueryError =
  GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500;

export function useGetApiAccountKycStatus<
  TData = Awaited<ReturnType<typeof getApiAccountKycStatus>>,
  TError = GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountKycStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountKycStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountKycStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountKycStatus<
  TData = Awaited<ReturnType<typeof getApiAccountKycStatus>>,
  TError = GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountKycStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountKycStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountKycStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountKycStatus<
  TData = Awaited<ReturnType<typeof getApiAccountKycStatus>>,
  TError = GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountKycStatus>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du statut KYC
 */

export function useGetApiAccountKycStatus<
  TData = Awaited<ReturnType<typeof getApiAccountKycStatus>>,
  TError = GetApiAccountKycStatus401 | GetApiAccountKycStatus403 | GetApiAccountKycStatus500,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountKycStatus>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountKycStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Envoie un email avec un lien pour creer le premier mot de passe. Utilise pour les nouveaux comptes n'ayant jamais defini de mot de passe.
 * @summary Initialisation de la creation du mot de passe
 */
export const postAppAccountPasswordinitializeInvoke = (
  passwordInitializeRequest: PasswordInitializeRequest,
  signal?: AbortSignal
) => {
  return postAppAccountPasswordinitializeInvokeMutator<PostAppAccountPasswordinitializeInvoke200>({
    url: `/api/account/initialize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordInitializeRequest,
    signal,
  });
};

export const getPostAppAccountPasswordinitializeInvokeMutationKey = () =>
  ['postAppAccountPasswordinitializeInvoke'] as const;

export const getPostAppAccountPasswordinitializeInvokeMutationOptions = <
  TError = PostAppAccountPasswordinitializeInvoke400,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>,
    TError,
    PostAppAccountPasswordinitializeInvokeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>,
  TError,
  PostAppAccountPasswordinitializeInvokeMutationVariables,
  TContext
> => {
  const mutationKey = getPostAppAccountPasswordinitializeInvokeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>,
    PostAppAccountPasswordinitializeInvokeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postAppAccountPasswordinitializeInvoke(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAppAccountPasswordinitializeInvokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>
>;
export type PostAppAccountPasswordinitializeInvokeMutationBody = PasswordInitializeRequest;
export type PostAppAccountPasswordinitializeInvokeMutationError = PostAppAccountPasswordinitializeInvoke400;
export type PostAppAccountPasswordinitializeInvokeMutationVariables = { data: PasswordInitializeRequest };

/**
 * @summary Initialisation de la creation du mot de passe
 */
export const usePostAppAccountPasswordinitializeInvoke = <
  TError = PostAppAccountPasswordinitializeInvoke400,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>,
      TError,
      PostAppAccountPasswordinitializeInvokeMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAppAccountPasswordinitializeInvoke>>,
  TError,
  PostAppAccountPasswordinitializeInvokeMutationVariables,
  TContext
> => {
  return useMutation(getPostAppAccountPasswordinitializeInvokeMutationOptions(options), queryClient);
};
/**
 * Envoie un email de reinitialisation de mot de passe avec un lien securise. Utilise lorsqu'un utilisateur a oublie son mot de passe.
 * @summary Demande de reinitialisation du mot de passe
 */
export const postAppAccountPasswordresetInvoke = (passwordResetRequest: PasswordResetRequest, signal?: AbortSignal) => {
  return postAppAccountPasswordresetInvokeMutator<PostAppAccountPasswordresetInvoke200>({
    url: `/api/account/reset`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordResetRequest,
    signal,
  });
};

export const getPostAppAccountPasswordresetInvokeMutationKey = () => ['postAppAccountPasswordresetInvoke'] as const;

export const getPostAppAccountPasswordresetInvokeMutationOptions = <
  TError = PostAppAccountPasswordresetInvoke400 | PostAppAccountPasswordresetInvoke401,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>,
    TError,
    PostAppAccountPasswordresetInvokeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>,
  TError,
  PostAppAccountPasswordresetInvokeMutationVariables,
  TContext
> => {
  const mutationKey = getPostAppAccountPasswordresetInvokeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>,
    PostAppAccountPasswordresetInvokeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postAppAccountPasswordresetInvoke(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAppAccountPasswordresetInvokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>
>;
export type PostAppAccountPasswordresetInvokeMutationBody = PasswordResetRequest;
export type PostAppAccountPasswordresetInvokeMutationError =
  PostAppAccountPasswordresetInvoke400 | PostAppAccountPasswordresetInvoke401;
export type PostAppAccountPasswordresetInvokeMutationVariables = { data: PasswordResetRequest };

/**
 * @summary Demande de reinitialisation du mot de passe
 */
export const usePostAppAccountPasswordresetInvoke = <
  TError = PostAppAccountPasswordresetInvoke400 | PostAppAccountPasswordresetInvoke401,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>,
      TError,
      PostAppAccountPasswordresetInvokeMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAppAccountPasswordresetInvoke>>,
  TError,
  PostAppAccountPasswordresetInvokeMutationVariables,
  TContext
> => {
  return useMutation(getPostAppAccountPasswordresetInvokeMutationOptions(options), queryClient);
};
/**
 * Valide le token de reinitialisation et definit un nouveau mot de passe. Le token est fourni dans l'email envoye via les endpoints d'initialisation ou de reinitialisation.
 * @summary Validation et definition du nouveau mot de passe
 */
export const postAppAccountPasswordvalidateInvoke = (
  passwordValidateRequest: PasswordValidateRequest,
  signal?: AbortSignal
) => {
  return postAppAccountPasswordvalidateInvokeMutator<PostAppAccountPasswordvalidateInvoke200>({
    url: `/api/account/validate-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordValidateRequest,
    signal,
  });
};

export const getPostAppAccountPasswordvalidateInvokeMutationKey = () =>
  ['postAppAccountPasswordvalidateInvoke'] as const;

export const getPostAppAccountPasswordvalidateInvokeMutationOptions = <
  TError = PostAppAccountPasswordvalidateInvoke400,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>,
    TError,
    PostAppAccountPasswordvalidateInvokeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>,
  TError,
  PostAppAccountPasswordvalidateInvokeMutationVariables,
  TContext
> => {
  const mutationKey = getPostAppAccountPasswordvalidateInvokeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>,
    PostAppAccountPasswordvalidateInvokeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postAppAccountPasswordvalidateInvoke(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAppAccountPasswordvalidateInvokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>
>;
export type PostAppAccountPasswordvalidateInvokeMutationBody = PasswordValidateRequest;
export type PostAppAccountPasswordvalidateInvokeMutationError = PostAppAccountPasswordvalidateInvoke400;
export type PostAppAccountPasswordvalidateInvokeMutationVariables = { data: PasswordValidateRequest };

/**
 * @summary Validation et definition du nouveau mot de passe
 */
export const usePostAppAccountPasswordvalidateInvoke = <
  TError = PostAppAccountPasswordvalidateInvoke400,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>,
      TError,
      PostAppAccountPasswordvalidateInvokeMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAppAccountPasswordvalidateInvoke>>,
  TError,
  PostAppAccountPasswordvalidateInvokeMutationVariables,
  TContext
> => {
  return useMutation(getPostAppAccountPasswordvalidateInvokeMutationOptions(options), queryClient);
};
/**
 * Recuperation des informations de profil de l'utilisateur authentifie, incluant les donnees personnelles et les coordonnees depuis Salesforce.
 * @summary Recuperation du profil utilisateur
 */
export const getApiAccountProfile = (signal?: AbortSignal) => {
  return getApiAccountProfileMutator<ProfileResponse>({ url: `/api/account/profile`, method: 'GET', signal });
};

export const getGetApiAccountProfileQueryKey = () => {
  return [`/api/account/profile`] as const;
};

export const getGetApiAccountProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAccountProfile>>,
  TError = GetApiAccountProfile422,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountProfile>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAccountProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAccountProfile>>> = ({ signal }) =>
    getApiAccountProfile(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAccountProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAccountProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAccountProfile>>>;
export type GetApiAccountProfileQueryError = GetApiAccountProfile422;

export function useGetApiAccountProfile<
  TData = Awaited<ReturnType<typeof getApiAccountProfile>>,
  TError = GetApiAccountProfile422,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountProfile>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountProfile<
  TData = Awaited<ReturnType<typeof getApiAccountProfile>>,
  TError = GetApiAccountProfile422,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAccountProfile>>,
          TError,
          Awaited<ReturnType<typeof getApiAccountProfile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAccountProfile<
  TData = Awaited<ReturnType<typeof getApiAccountProfile>>,
  TError = GetApiAccountProfile422,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountProfile>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du profil utilisateur
 */

export function useGetApiAccountProfile<
  TData = Awaited<ReturnType<typeof getApiAccountProfile>>,
  TError = GetApiAccountProfile422,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAccountProfile>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAccountProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
